// config.js

export const MICRO_TYPES = ['Umik1', 'EARS', 'Audyx', 'Umik2'];

export const MICRO_COLORS = {
  Umik1: '#bfdbfe',
  EARS:  '#a7f3d0',
  Audyx: '#fde68a',
  Umik2: '#ddd6fe',
};

export const MICRO_TEXT_COLORS = {
  Umik1: '#1d4ed8',
  EARS:  '#047857',
  Audyx: '#b45309',
  Umik2: '#6d28d9',
};


